var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "customcheckerboard-wrap-selector"
  }, [_c('div', {
    class: ['customcheckerboard-wrap-selector-body', 'customcheckerboard-main-views-wrapper-body']
  }, [_c('h5', {
    class: ['customcheckerboard-wrap-selector-title', 'customcheckerboard-main-views-wrapper-title', 'text-center']
  }, [_vm._v(_vm._s(_vm.translations.customCheckerboardWarpTitle))]), _vm.canvasLoaded ? _c('div', {
    staticClass: "customcheckerboard-wrap-selector-container"
  }, _vm._l(_vm.warps, function (item, warp) {
    return _c('div', {
      key: warp,
      staticClass: "customcheckerboard-wrap-selector-item"
    }, [_c('div', {
      class: ['customcheckerboard-wrap-selector-image', {
        'customcheckerboard-wrap-selector-image-active': warp === _vm.selectedWarp
      }],
      style: {
        backgroundColor: _vm.$store.state.customCheckerboard.canvasConfig.color1
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: warp === _vm.selectedWarp,
        expression: "warp === selectedWarp"
      }],
      staticClass: "customcheckerboard-size-selector-icon-check icon-check"
    }), _c('warp-glfx', {
      attrs: {
        "warp-info": item,
        "warp-name": warp,
        "is-selected": warp === _vm.selectedWarp
      },
      on: {
        "warpSelected": _vm.warpSelected,
        "warpLoaded": _vm.warpLoaded
      }
    })], 1), _c('span', {
      staticClass: "customcheckerboard-wrap-selector-label"
    }, [_vm._v(_vm._s(_vm.translations[item.label]))])]);
  }), 0) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }